import React, { useState } from "react";
import "../../style/RegisterForm.css";
import logo from "../assets/logo.png";
import github from "../assets/Github.png";
import google from "../assets/Google.png";
import linkedin from "../assets/LinkedIn.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext"; // ✅ Import useAuth hook

const RegistrationPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const API_BASE_URL = process.env.REACT_APP_API_SOURCE;

  const [formData, setFormData] = useState({
    email: "",
    username: "",
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [isPasswordFocused, setIsPasswordFocused] = useState(false); // ✅ Track focus on password input
  const [passwordValidations, setPasswordValidations] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "password") {
      setPasswordValidations({
        length: value.length >= 8,
        uppercase: /[A-Z]/.test(value),
        lowercase: /[a-z]/.test(value),
        number: /[0-9]/.test(value),
        special: /[!@#$%^&*]/.test(value),
      });
    }
  };

  const validateEmail = (email) => /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email);
  const validatePassword = (password) =>
    password.length >= 8 &&
    /[A-Z]/.test(password) &&
    /[a-z]/.test(password) &&
    /[0-9]/.test(password) &&
    /[!@#$%^&*]/.test(password);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!validateEmail(formData.email)) {
      setError("Invalid email format");
      setLoading(false);
      return;
    }

    if (!validatePassword(formData.password)) {
      setError("Password does not meet the requirements");
      setLoading(false);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/backend/api/RegisterForm/register.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            username: formData.username,
            email: formData.email,
            password: formData.password,
          }),
        }
      );
  
      const result = await response.json();
      console.log("Server Response:", result);
  
      setLoading(false);
  
      if (result.status === "success" && result.userId) {
  
        // ✅ Store userId and log in
        login(result.userId);
        localStorage.setItem("userId", result.userId);
        localStorage.setItem("isAuthenticated", "true"); // Ensure authentication persistence
  
        // ✅ Redirect to homepage
        navigate("/home");
      } else {
        setError(result.message);
      }
    } catch (error) {
      console.error("Registration error:", error);
      setError("An error occurred. Please try again.");
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-box">
        <div className="logo-container">
          <img src={logo} alt="LockedIn Logo" className="logo" />
        </div>

        <p className="register-title">Create your Account</p>
        <form onSubmit={handleSubmit} className="register-form">
          <input type="email" name="email" placeholder="Email" onChange={handleChange} required />
          <input type="text" name="username" placeholder="Username" onChange={handleChange} required />
          <div className="password-container">
              <input
                type="password"
                name="password"
                placeholder="Password"
                onChange={handleChange}
                onFocus={() => setIsPasswordFocused(true)}
                onBlur={() => setIsPasswordFocused(false)}
                required
              />
              {isPasswordFocused && (
                          <div className={`password-requirements ${isPasswordFocused ? "visible" : "hidden"}`}>
                          <div className="password-arrow"></div> {/* ✅ Arrow stays attached */}
                          <p className={passwordValidations.length ? "valid" : "invalid"}>
                            <span className="icon">{passwordValidations.length ? "✔" : "❌"}</span> 
                            At least 8 characters
                          </p>
                          <p className={passwordValidations.uppercase ? "valid" : "invalid"}>
                            <span className="icon">{passwordValidations.uppercase ? "✔" : "❌"}</span> 
                            At least one uppercase letter
                          </p>
                          <p className={passwordValidations.lowercase ? "valid" : "invalid"}>
                            <span className="icon">{passwordValidations.lowercase ? "✔" : "❌"}</span> 
                            At least one lowercase letter
                          </p>
                          <p className={passwordValidations.number ? "valid" : "invalid"}>
                            <span className="icon">{passwordValidations.number ? "✔" : "❌"}</span> 
                            At least one number
                          </p>
                          <p className={passwordValidations.special ? "valid" : "invalid"}>
                            <span className="icon">{passwordValidations.special ? "✔" : "❌"}</span> 
                            At least one special character
                          </p>
                        </div>
              
  )}
          </div>
          <input type="password" name="confirmPassword" placeholder="Re-enter Password" onChange={handleChange} required />
          {error && <p className="error">{error}</p>}
          <button type="submit" className="register-btn" disabled={loading}>
            {loading ? "Registering..." : "Register"}
          </button>
        </form>

        <div className="external-sign-in">
          <p>or continue with:</p>
          <div className="external-login">
            <a href="https://github.com/login">
              <img src={github} alt="Github" />
            </a>
            <a href="https://accounts.google.com/signin">
              <img src={google} alt="Google" />
            </a>
            <a href="https://www.linkedin.com/login">
              <img src={linkedin} alt="LinkedIn" />
            </a>
          </div>
        </div>

        <p className="login-link">
          <span className="white-text">Already have an account?</span> 
          <span onClick={() => navigate("/login")} className="login-text"> Sign in</span>
        </p>
      </div>
    </div>
  );
};

export default RegistrationPage;